import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ActionType} from "@/util/type/store.ts";
import {CreateAttribute} from "@/model/request/attribute/CreateAttribute.ts";
import {BaseResponse} from "@/model/response/BaseResponse.ts";
import {Attribute, ReadAttributeResponse} from "@/model/response/attribute/ReadAttributeResponse.ts";
import {CreateBulkAttributeRequest} from "@/model/request/attribute/CreateBulkAttributeRequest.ts";
import {DeleteAttribute} from "@/model/request/attribute/DeleteAttribute.ts";
import {UpdateAttribute} from "@/model/request/attribute/UpdateAttribute.ts";
import {ReadAttributeByEntityId} from "@/model/request/attribute/ReadAttributeByEntityId.ts";
import {AttributeService} from "@/service/AttributeService.ts";

export type AttributeState = {
    loading: boolean,
    attributes: Attribute[]
    attributeById: Attribute[]
    selectedAttribute: Attribute
}

const initialState: AttributeState = {
    loading: false,
    attributes: [],
    attributeById: [],
    selectedAttribute: {} as Attribute
}


const action = {
    createAttribute: createAsyncThunk('attribute/createAttribute', async (payload: ActionType<CreateAttribute>, thunkAPI) => {
        return (await AttributeService.create(thunkAPI, payload.data)).data;
    }),
    readAttributeByEntityId: createAsyncThunk('attribute/readAttributeByEntityId', async (payload: ReadAttributeByEntityId, thunkAPI) => {
        return (await AttributeService.readAttributeById(thunkAPI, payload)).data;
    }),
    updateAttribute: createAsyncThunk("attribute/updateAttribute", async (payload: ActionType<UpdateAttribute>, thunkAPI) => {
        return (await AttributeService.update(thunkAPI, payload.data)).data;
    }),
    bulkCreate: createAsyncThunk("attribute/bulkCreate", async (payload: ActionType<CreateBulkAttributeRequest>, thunkAPI) => {
        return (await AttributeService.bulkCreate(thunkAPI, payload.data)).data
    }),
    delete: createAsyncThunk("attribute/delete", async (payload: ActionType<DeleteAttribute>, thunkAPI) => {
        return (await AttributeService.delete(thunkAPI, payload.data)).data
    }),
    read: createAsyncThunk('attribute/read', async (_, thunkAPI) => {
        try {
            const response = await AttributeService.readAttribute(thunkAPI)
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.message)
        }
    }),
}
const slice = createSlice({
    name: "attribute",
    initialState,
    reducers: {
        setLoading(state, {payload}) {
            state.loading = payload;
        },
        setSelectedAttribute(state, {payload}) {
            state.selectedAttribute = payload;
        },
        setAttributeToEmpty(state,) {
            state.attributeById = [];
        },
        setAttributeById: (state, {payload}) => {
            console.log("papapap")
            state.attributeById = payload;
        },
        reset: () => ({...initialState})

    },
    extraReducers: (builder) => {
        builder.addCase(action.createAttribute.pending, state => {
            state.loading = true
        }).addCase(action.createAttribute.fulfilled, (state, action) => {
            const response = action.payload as BaseResponse;
            state.loading = false
            if (response.responseCode == "00") {
                action.meta.arg.onSuccess?.(action.payload)
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.readAttributeByEntityId.pending, (state) => {
            state.loading = true
            state.attributeById = []
        }).addCase(action.readAttributeByEntityId.fulfilled, (state, action) => {
            const response = action.payload as ReadAttributeResponse;
            state.loading = false
            if (response.responseCode == "00") {
                state.attributeById = response.data
            }
        }).addCase(action.updateAttribute.pending, (state) => {
            state.loading = true
        }).addCase(action.updateAttribute.fulfilled, (state, action) => {
            const response = action.payload as BaseResponse;
            state.loading = false
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload)
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.delete.pending, (state) => {
            state.loading = true
        }).addCase(action.delete.fulfilled, (state, action) => {
            const response = action.payload as BaseResponse;
            state.loading = false
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload)
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.bulkCreate.pending, (state) => {
            state.loading = true
        }).addCase(action.bulkCreate.fulfilled, (state, action) => {
            const response = action.payload as BaseResponse;
            state.loading = false
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload)
            } else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.read.pending, (state) => {
            state.loading = true
        }).addCase(action.read.fulfilled, (state, action) => {
            const response = action.payload as ReadAttributeResponse;
            state.loading = false
            if (response.responseCode === "00") {
                state.attributes = response.data
            }
        })
    }

})

export const attribute = {
    reducer: slice.reducer,
    action,
    mutation: slice.actions
}
